import { getDocs, onSnapshot, query, startAfter } from "firebase/firestore";
import { useState } from "react";

export function usePagination(docRef) {
  const [paginatedList, setList] = useState([]);

  const [lastDoc, setLastDoc] = useState();

  const getList = () => {
    onSnapshot(docRef, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id, // map document id
      }));
      // set collection data
      setList(data);
      const lastDoc = snapshot.docs[snapshot.docs.length - 1]; // get snapshot of last document
      setLastDoc(lastDoc);
    });
  };

  // update current paginated list
  const updateState = (snapshot) => {
    const data = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    // append to list
    setList((prev) => [...prev, ...data]);
    const lastDoc = snapshot.docs[snapshot.docs.length - 1]; // get snapshot of last document
    setLastDoc(lastDoc);
  };

  // get more documents
  const fetchMore = () => {
    getDocs(query(docRef, startAfter(lastDoc))).then((snapshot) => {
      updateState(snapshot);
    });
  };

  return { fetchMore, paginatedList, setList, getList };
}
